import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X4Unit, X4UnitUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class EditUnitStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly unit: X4Unit) {
    makeObservable(this);
    this.name = new StringControl('name', unit.Name, validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X4UnitUpdateModel = {
      LevelId: this.unit.LevelId,
      Index: this.unit.Index,
      Name: this.name.value
    };
    this.save = contentLoaders.x4unit.update(this.unit.Id, model);
  }
}
